// import { WSIBClassList } from "components/WSIBClass";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { WSIBCategoryList } from "../../components/WSIBCategoryList";

export interface IWSIBCategoryListPage { }

export const WSIBCategoryListPage: FC<IWSIBCategoryListPage> = (
  props: IWSIBCategoryListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Category List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<WSIBCategoryList />}
    />
  );
};
